import { useCallback } from 'react';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';
import {
  CommunityEventLabels,
  CommunityEventsMap,
  type TrackCommunityEvent,
} from './events';

/**
 * Custom hook to handle community tracking events
 */
export function useTrackCommunityAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackCommunityEvent, extra?: Record<string, unknown>) => {
      const eventLabel = CommunityEventLabels[event];
      const eventInfo = CommunityEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
